export default __webpack_public_path__ + "static/media/final-logos-colour-02.a7804cf3.png";